import React from "react"
import { Spin } from "antd"
import { LoadingOutlined } from "@ant-design/icons"

interface LoaderProps {
  fontSize: number
  color: string
  margin?: string // margin is optional
  size?: "small" | "default" | "large" // size is optional with specific allowed values
}

/**
 * Loader component to display a loading spinner.
 * It uses Ant Design's Spin component with a custom loading icon.
 */
export const Loader: React.FC<LoaderProps> = ({
  fontSize,
  color,
  margin, // Default will be undefined if not provided
  size = "default", // Provide a default value for optional props
}) => {
  const loaderIconStyle: React.CSSProperties = {
    fontSize: fontSize,
    color: color,
  }

  if (margin) {
    loaderIconStyle.margin = margin // Conditionally add margin
  }

  const LoaderIcon = <LoadingOutlined style={loaderIconStyle} spin />

  return (
    <Spin
      className="flex items-center justify-center"
      indicator={LoaderIcon}
      size={size}
      data-testid="loader-spin"
    />
  )
}
